var Base = require('_js/base'),
  $ = require('jquery');

function BlockList() {
  this.init();
}

BlockList.prototype = new Base();

BlockList.prototype.init = function() {
  var $dataReset = $('[data-reset-registration-session]');
  if ($dataReset.get(0) !== undefined) {
    sessionStorage.removeItem('rn-registration');
  }
};

module.exports = BlockList;
